import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from '@material-ui/core/Container';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  root: {
    marginTop: theme.spacing(1),
    maxWidth: 500,
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiIconButton-root': { padding: 0 },
    '& .PrivateSwitchBase-root-91': {
      padding: theme.spacing(0.25),
    },
    '& .MuiIconButton-label': {
      marginRight: theme.spacing(1),
    },
    border: '2px solid rgba(0, 0, 0, 0.08)',
    boxSizing: 'border-box',
    borderRadius: 12,
  },
  checkbox: {
    color: 'black',
    marginTop: 8,
  },
  text: {
    marginTop: 8,
    marginBottom: 8,
  },
}));

export default function AcceptTerms({ acceptedTerms, setAcceptedTerms }) {
  const classes = useStyles();

  function handleChange() {
    setAcceptedTerms(!acceptedTerms);
  }

  return (
    <Container className={classes.root}>
      <Checkbox
        onChange={handleChange}
        className={classes.checkbox}
        color="default"
        data-automation-id="acceptTerms"
      />
      <Typography className={classes.text}>
        I understand that the Growth Plan terms presented to me will not be
        final until I link my Bank account.
      </Typography>
    </Container>
  );
}
